import React, { FC, SyntheticEvent, useContext } from 'react';
import { faPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FlightPart } from '../../ts/interfaces/OphirResponse';
import { getClassNameByStatus, getImgUrl, getTextByStatus } from '../../utils';
import { useTranslation } from 'react-i18next';
import { cdnUrl, imgBg } from '../../constants';

interface OphirFlightCardProps {
  flight: FlightPart;
  returnFlight: FlightPart;
  icon: any;
  title: string;
  success?: boolean;
  flightStatus?: string;
}

const OphirFlightCard: FC<OphirFlightCardProps> = ({
  flight,
  returnFlight,
  title,
  icon,
  success,
  flightStatus,
}) => {
  const [t] = useTranslation() as unknown as [(key: string) => string];
  const onImageLoadError = ({ currentTarget }: SyntheticEvent<HTMLImageElement, Event>) => {
    currentTarget.onerror = null;
    currentTarget.src = imgBg;
  };

  return (
    <div className={'oph-ticket default-shadow' + (success ? 'oph-ticket-success' : '')}>
      <div className="oph-ticket-header">
        <FontAwesomeIcon icon={icon} />
        <span>{title}</span>
      </div>
      <div className="oph-ticket-logo">
        <img src={getImgUrl(flight.airlineLogo, cdnUrl)} alt="logo" onError={onImageLoadError} />
        <span className="name">{flight.airlineDesc}</span>
      </div>
      <div className="oph-ticket-route">
        <div className="city">
          {!!flight.cityName && <span>{flight.cityName} - </span>}
          <span className="code">{flight.cityCode}</span>
        </div>
        <div className="time">{flight.time}</div>
        <div className="date">{flight.date}</div>
      </div>
      <div className="oph-ticket-separator">
        <span className="type-flight">{t('flight.charter')}</span>
        <span className="circle"></span>
        <FontAwesomeIcon icon={faPlane as any} />
      </div>
      <div className="oph-ticket-route">
        <div className="city">
          {!!returnFlight.cityName && <span>{returnFlight.cityName} - </span>}
          <span className="code">{returnFlight.cityCode}</span>
        </div>
        <div className="time">{returnFlight.time}</div>
        <div className="date">{returnFlight.date}</div>
      </div>
      {success && flightStatus && (
        <div className="oph-ticket-ok">
          <span className={getClassNameByStatus(flightStatus)}>
            {getTextByStatus(flightStatus)}
          </span>
        </div>
      )}
    </div>
  );
};

export default OphirFlightCard;
